"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PointerType;
(function (PointerType) {
    PointerType["MOUSE"] = "MOUSE";
    PointerType["HOVER"] = "HOVER";
    PointerType["TOUCH"] = "TOUCH";
    PointerType["VIRTUAL"] = "VIRTUAL";
})(PointerType || (PointerType = {}));
exports.default = PointerType;
//# sourceMappingURL=PointerType.js.map